import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

/**
 * @typedef GetMissionsByCityQueryVars
 * @property {number} cityId Mandatory city id
 * @property {string} statusAndAbove Filter by status
 * @property {string} statusAndBelow Filter by status
 * @property {string} timeOfDay Filter by time of day
 * @property {number} campaignId Filter by campaign
 * @property {string} startDate Filter by start date
 * @property {string} endDate Filter by end date
 *
 * Get missions within a city
 * @param {GetMissionsByCityQueryVars} queryVars
 */
export const getMissionsByCity = function(queryVars) {
  var query = `query (
    $first:Int
    $skip:Int
    $cityId:ID!
    $startDate:String
    $endDate:String
    $statusAndAbove: MissionStatusEnum
    $statusAndBelow: MissionStatusEnum
    $timeOfDay: MissionTimeOfDayEnum
    $filter:String
    $orderBy:MissionOrderByEnum
    $canBeSpied: Boolean
    $spyUserId: ID
    $hasAssignedSpy: Boolean
    $spyCheckedIn: Boolean
    $spyCheckedOut: Boolean
    $reported: Boolean
  ) {
    city(id: $cityId){
      id
      name
      country { id }
      lunchCheckInTime
      afternoonCheckInTime
      missions(
        first: $first
        skip: $skip
        startDate: $startDate
        endDate: $endDate
        statusAndAbove: $statusAndAbove
        statusAndBelow: $statusAndBelow
        timeOfDay: $timeOfDay
        filter: $filter
        orderBy: $orderBy
        canBeSpied: $canBeSpied
        spyUserId: $spyUserId
        hasAssignedSpy: $hasAssignedSpy
        spyCheckedIn: $spyCheckedIn
        spyCheckedOut: $spyCheckedOut
        reported: $reported
      ){
        edges {
          node {
            id
            dateTime
            status
            rating
            checkInTime
            checkoutTime
            cityPlan {
              campaign {
                client {
                  name
                }
              }
              city {
                afternoonCheckInTime
                lunchCheckInTime
              }
            }
            location {
              name
            }
            user {
              firstName
              lastName
            }
            canBeSpied
            spyInformation {
              spy {
                id
                firstName
                lastName
                status
              }
              spyDetails {
                checkInTime
                checkoutTime
                reportReason
              }
            }
          }
        }
        pageInfo {
          hasNextPage
        }
        totalCount
      }
    }
  }`

  return callAuthorizedGraphQLEndpoint(query, queryVars)
}



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spy/Roster/graphql.js